module.exports = __webpack_public_path__ + "static/media/icon.328cea88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NeedsSelect/icon.svg
// module id = 322
// module chunks = 0